import { Injectable } from "@angular/core";
import { IExceptionTelemetry } from '@microsoft/applicationinsights-web';
import { AppInsightsService } from "@overtur/app-insights";

@Injectable()
export class ApplicationInsightsService extends AppInsightsService {

  logPageView(
    name?: string,
    url?: string,
    properties?: { [name: string]: string },
    measurements?: any,
    duration?: number
  ) {
    this.appInsights.trackPageView(
      {
        name,
        uri: url,
        properties: { duration, ...properties },
        measurements
      }
    );
  }

  logEvent(
    name: string,
    properties?: { [name: string]: string },
    measurements?: { [name: string]: number }
  ) {
    this.appInsights.trackEvent(
      { name },
      { properties, measurements }
    );
  }

  logError(exception: Error) {
    const telemetry = {
      exception
    } as IExceptionTelemetry;
    this.appInsights.trackException(telemetry);
  }

  setUserContext(
    authenticatedUserId: string,
    accountId?: string,
    storeInCookie?: boolean
  ) {
    this.appInsights.setAuthenticatedUserContext(
      authenticatedUserId,
      accountId,
      storeInCookie
    );
  }
}